// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"userVoiceMessage_mainContainer__3RpFO","userImg":"userVoiceMessage_userImg__25TqF","messageContainer":"userVoiceMessage_messageContainer__3mUaS"};